import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
    verifyPayment,
} from "../services/payments";

export function useVerifyPayment() {

    const queryClient =
        useQueryClient();

    return useMutation({

        mutationFn: verifyPayment,

        onSuccess: () => {

            queryClient.invalidateQueries({

                queryKey: ["wallet"],

            });

            queryClient.invalidateQueries({

                queryKey: ["transactions"],

            });

            queryClient.invalidateQueries({

                queryKey: ["overview"],

            });

        },

    });

}